<template>
  <div>
    <div class="dingbuIdyanseOne">
      <div class="dingbuIdTwo main">
        <div class="wailian wailianPo">
          <div class="wailianTwo">
            <a href='http://www.sinomach.com.cn/' target='_blank' class="menu-item-link menuOneRow">国机集团</a>
          </div>
        </div>
        <div class="wailian">
          <div class="wailianOne">
            <a href='http://texdigi.com/#/' target='_blank' class="menu-item-link menuOneRow">数智纺</a>
          </div>
        </div>
        <div class="wailian">
          <div class="wailianTwo">
            <a href='https://www.71ydj.com/' target='_blank' class="menu-item-link menuOneRow">七一云党建</a>
          </div>
        </div>
        <div class="duotu">
          <img v-on:mouseover="changeActive()" v-on:mouseout="removeActive()" class="dingbuIdImg1" src="https://oss.cloudcpc.com/ind-weixin.png" alt="">
          <img :class="{'yincan':current===0}" src="https://oss.cloudcpc.com/ind-tc.png" alt="">
          <img :class="{'yincan':current===0}" src="https://oss.cloudcpc.com/ind-weixin1.png" alt="">
        </div>
        <a target="_blank" href="https://weibo.com/u/7729578882"><img src="https://oss.cloudcpc.com/ind-weibo.png" alt=""></a>
        <a target="_blank" href="https://www.zhihu.com/org/guo-ji-zhong-zhi-wang"><img src="https://oss.cloudcpc.com/ind-zhihu.png" alt=""></a>
        <a target="_blank" href="https://b23.tv/R5alEZl"><img src="https://oss.cloudcpc.com/ind-bizhan.png" alt=""></a>
      </div>
    </div>

    <div class="dingbuIdyanseTwo">
      <ul id="dingbuId">
        <li class="dingbuIdOne" @click="toAllIndex()">
          <img src="https://oss.cloudcpc.com/logo(1).png" alt="">
        </li>
        <li class="dingbuIdxinz">
          <div :class="['header-menu-item']">
            <router-link to='/allIndex' target='_blank' class="menu-item-link menuOneRow">首页</router-link>
          </div>
          <div @mouseout='vrNav()' @mouseover="revrNav()" :class="['header-menu-item']">
            <router-link id="varId" to='/vr' target='_blank' class="menu-item-link menuOneRow">VR/AR</router-link>
          </div>
          <div @mouseout='moveNav()' @mouseover="removeNav()" :class="['header-menu-item']">
            <router-link id="yunId" to='/index' target='_blank' class="menu-item-link menuOneRow">云上展</router-link>
          </div>
          <div @mouseout='moveFateNav()' @mouseover="removeFateNav()" :class="['header-menu-item']">
            <router-link id="bangId" to='/digitIndex' target='_blank' class="menu-item-link menuOneRow">数智邦</router-link>
          </div>
          <div :class="['header-menu-item']">
            <router-link id="xunId" to='/news' target='_blank' class="menu-item-link menuOneRow">资讯专区</router-link>
          </div>
          <div :class="['header-menu-item']">
            <router-link id="vidId" to='/videoList' target='_blank' class="menu-item-link menuOneRow">视频专区</router-link>
          </div>
          <div :class="['header-menu-item']">
            <router-link to='/about' target='_blank' class="menu-item-link menuOneRow">关于我们</router-link>
          </div>
        </li>

      </ul>
    </div>
    <v-header />
    <f-header />
    <v-rheader />
    <transition name="fade">
      <div id="app">
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </transition>
    <template v-if="!$route.meta.withoutFoot">
      <!-- <Apply /> -->
      <Foot />
    </template>
    <admcontact :dialogShowIf="$store.state.dialogShowIf"></admcontact>
  </div>
</template>
<script>
// import Vheader from "../components/Header";
import Foot from "../components/Foot";
import Apply from "../components/Apply";
export default {
  data() {
    return {
      //导航
      current: 0,
      dialogShowIf: false,
      //页面的导航栏位置
      navAllIndex: 0,
    };
  },
  components: {
    // "v-header": Vheader,
    // "f-header":Fheader,
    Foot,
    Apply,
  },
  mounted() {
    this.navData();
  },
  methods: {
    //跳转总首页
    toAllIndex() {
      var routeUrl = this.$router.resolve({
        path: "/allIndex",
      });
      window.open(routeUrl.href, "_blank");
    },
    //记住导航栏切换位置
    navData() {
      if (sessionStorage.getItem("navIndex")) {
        var navIndex = JSON.parse(sessionStorage.getItem("navIndex"));
        this.navAllIndex=navIndex
      }
    },
    changeActive() {
      this.current = 1;
    },
    removeActive() {
      this.current = 0;
    },
    //移入显示导航栏
    moveNav() {
      this.$store.commit("SET_ISNAV", false);
    },
    removeNav() {
      this.$store.commit("SET_ISNAV", true);
    },
    moveFateNav() {
      this.$store.commit("SET_ISFATENAV", false);
    },
    removeFateNav() {
      this.$store.commit("SET_ISFATENAV", true);
    },
    vrNav() {
      this.$store.commit("SET_ISVRNAV", false);
    },
    revrNav() {
      this.$store.commit("SET_ISVRNAV", true);
    },
  },
  created() {},
};
</script>


<style lang="scss">
// @import "../components/Header/index.scss";

#dingbuId {
  width: 1200px;
  height: 66px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  z-index: 99999;
  position: relative;
  background: #ffffff;
  .dingbuIdOne {
    cursor: pointer;
  }
}
.dingbuIdxinz {
  display: flex;
  justify-content: space-between;
  width: 650px;
  .header-menu-item {
    width: 100%;
    height: 66px;
    line-height: 66px;
    text-align: center;
    cursor: pointer;
    font-size: 15px;
    color: #505c6b;

    & > .active {
      background: #1676ff;
      color: #fff;
    }
  }
  .yiru {
    background: #1676ff;
    color: #fff;
  }
  .header-menu-item:hover {
    transition: all 0.15s ease-in-out;
    background: #1676ff;
    color: #fff;
    .menu01-box {
      opacity: 1;
      transition: all 0.15s ease-in-out;
    }
    .menu-item-link{
      color: #ffffff;
    }
  }
  .menu-item-link {
    width: 100%;
    height: 66px;
    display: inline-block;
  }
}
.dingbuIdyanseOne {
  background: #f7f9fc;
  height: 50px;
  position: relative;
  z-index: 999999;
}
.dingbuIdyanseTwo {
  box-shadow: 0px 17px 21px 0px rgba(0, 0, 0, 0.09);
}

.dingbuIdTwo {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  height: 50px;
  .wailianPo {
    position: absolute;
    left: 0;
    font-size: 20px;
  }
  .duotu {
    & > :nth-child(1) {
      // position: absolute;
      // top: 7px;
      // left: 960px;
      cursor: pointer;
    }
    & > :nth-child(2) {
      position: absolute;
      top: 110px;
      left: 885px;
    }
    & > :nth-child(3) {
      position: absolute;
      top: 140px;
      left: 909px;
    }
    .yincan {
      display: none;
    }
  }
  & > img,
  a {
    margin-left: 15px;
  }
}
.wailian {
  margin-right: 18px;
  font-size: 17px;
  a {
    margin-left: 0;
  }
  a:hover {
    margin-left: 0;
    color: blue;
  }
}

html {
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 16px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
}

.button--green {
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #3b8070;
  color: #3b8070;
  text-decoration: none;
  padding: 10px 30px;
}

.button--green:hover {
  color: #fff;
  background-color: #3b8070;
}

.button--grey {
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #35495e;
  color: #35495e;
  text-decoration: none;
  padding: 10px 30px;
  margin-left: 15px;
}

.button--grey:hover {
  color: #fff;
  background-color: #35495e;
}
</style>
